export const domainStates = {
  //0 is initial active.
  InitialActive: 0,
  BZActivated: 1,
  BZWPPluginActivated: 2,
  BZRemoved: 3,
  BZWPPluginDeactivated: 4,
  BZWPPluginUninstalled: 5,
  CCSubscriptionCancellation: 6,
  CCDomainMoved: 7,
  CCDomainDeactivated: 8,
  PluginActivated: 9,
  PluginDeactivated: 10,
}
